import type { SpaceSummary } from '@/types/spaces';

/**
 * Discriminated union the credentials page passes down to its children so
 * action handlers know which list-endpoint to write against and which API
 * shape (user vs space vs org) to use.
 *
 * `user` covers the caller's own personal credentials, which live on the
 * user principal (`/me/credentials`) — not in any space. The Personal tab
 * routes here. `space` is shared spaces. `org` is the org-admin tab.
 */
export type Scope =
  | { kind: 'user' }
  | { kind: 'space'; spaceId: string; spaceName: string }
  | { kind: 'org' };

export function scopeTabId(scope: Scope): string {
  if (scope.kind === 'user') return 'user';
  if (scope.kind === 'org') return 'org';
  return `space:${scope.spaceId}`;
}

export function scopeFromTabId(
  id: string,
  spaces: SpaceSummary[],
): Scope | null {
  if (id === 'user') return { kind: 'user' };
  if (id === 'org') return { kind: 'org' };
  const m = /^space:(.+)$/.exec(id);
  if (!m) return null;
  const space = spaces.find((s) => s.spaceId === m[1]);
  if (!space) return null;
  return {
    kind: 'space',
    spaceId: space.spaceId,
    spaceName: space.name,
  };
}
